import React, { useState } from 'react';

import { LazyImage, LazyImageFull, ImageState } from "react-lazy-images";
import { VALoading } from '../../components';



type VALazyImageProps = {
    src: string;
    alt?: string;
}

function VALazyImage(props:VALazyImageProps) {
    return(
        <div className="photo">
            <div className="inner">
            <LazyImage
                src={props.src}
                alt={props.alt}
                actual={({ imageProps }) => <img {...imageProps} />}
                placeholder={({ ref }) => <div ref={ref} />}
                loading={() => (
                    <VALoading />
                )}
                error={() => (
                    <p>There was an error fetching this image :(</p>
                )}
            />
            </div>
        </div>
    )
}

export default VALazyImage;
